import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
import helpers from 'src/styles/helpers';
import sections from 'src/styles/sections';
const useStylesVoidStatementModalContent = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  modalContent: {
    padding: '24px 40px'
  },
  modalFooter: {
    borderTop: "1px solid ".concat(palette.shades[300]),
    padding: '32px 40px',
    textAlign: 'right'
  }
}));
export default useStylesVoidStatementModalContent;